import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { Draggable } from "react-beautiful-dnd";
import { PostPageTodoListWithListNavigation } from "../PostPageTodoList";
const PostPageTodosTodoLists = (props)=>{
    const { todoLists , disabled , todoSingularAction , todoSupportedActions  } = props;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: todoLists.map((todoList, index)=>{
            return /*#__PURE__*/ _jsx(Draggable, {
                isDragDisabled: disabled,
                draggableId: String(todoList.id),
                index: index,
                children: (dragProvided)=>/*#__PURE__*/ _jsx(PostPageTodoListWithListNavigation, {
                        todoList: todoList,
                        disabled: disabled,
                        index: index,
                        dragProvided: dragProvided,
                        todoSingularAction: todoSingularAction,
                        todoSupportedActions: todoSupportedActions
                    })
            }, todoList.nodeId);
        })
    });
};
export default /*#__PURE__*/ memo(PostPageTodosTodoLists);
